import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type {
	ApplicationLinkCreationEntity,
	ApplicationLinkCreationResponse,
} from './CommonApplicationLinkCreationEntity.tsx';

// ApplicationLinkV3Resource
export const createOAuth2Applink = (
	entity: ApplicationLinkCreationEntity,
): Promise<ApplicationLinkCreationResponse> =>
	fetchJson('/rest/applinks/3.0/applinks', {
		method: 'POST',
		body: JSON.stringify(entity),
		headers: {
			'Content-Type': 'application/json',
		},
	});
